/** Preset choices for company brand colors (sidebar + primary brand). */
export const TENANT_SETUP_BRAND_COLOR_CHOICES = [
  "#0F172A",
  "#1D4ED8",
  "#2563EB",
  "#7C3AED",
  "#C026D3",
  "#DB2777",
  "#EA580C",
  "#CA8A04",
] as const;

/** Sidebar accent presets (distinct from brand list for clearer pairing). */
export const TENANT_SETUP_SIDEBAR_COLOR_CHOICES = [
  "#020617",
  "#14532D",
  "#166534",
  "#0E7490",
  "#1E40AF",
  "#5B21B6",
  "#831843",
  "#9A3412",
] as const;

export const TENANT_SETUP_BRAND_COLOR_SET = new Set<string>(
  TENANT_SETUP_BRAND_COLOR_CHOICES,
);

export const TENANT_SETUP_SIDEBAR_COLOR_SET = new Set<string>(
  TENANT_SETUP_SIDEBAR_COLOR_CHOICES,
);
